let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4fCJZ"), load("dTsOE"), load("x8U2P")]).then(() => parcelRequire('6yR7w'));